'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('@liveauctioneers/caterwaul-components/lib/button');

var _button2 = _interopRequireDefault(_button);

var _Checkbox = require('react-bootstrap/lib/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _FormattedMessage = require('../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _input = require('@liveauctioneers/caterwaul-components/lib/input');

var _input2 = _interopRequireDefault(_input);

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _validation = require('../../../utils/validation');

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpEmail = require('./SignUpEmail.scss');

var _SignUpEmail2 = _interopRequireDefault(_SignUpEmail);

var _throbber = require('@liveauctioneers/caterwaul-components/lib/throbber');

var _throbber2 = _interopRequireDefault(_throbber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpEmail = function (_Component) {
    (0, _inherits3.default)(SignUpEmail, _Component);

    function SignUpEmail() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SignUpEmail);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignUpEmail.__proto__ || (0, _getPrototypeOf2.default)(SignUpEmail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            agree: false,
            email: '',
            emailValid: true
        }, _this.shouldComponentUpdate = function (nextProps, nextState) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps) || !(0, _reactFastCompare2.default)(_this.state, nextState);
        }, _this.onValueChange = function (event) {
            var newState = {};
            newState[event.target.id] = event.target.value;
            _this.setState(newState);
        }, _this.onAgreeValueChange = function (event) {
            var newState = { agree: event.target.checked };
            _this.setState(newState);
        }, _this.onSignUp = function () {
            var email = _this.state.email.trim();
            var emailValid = (0, _validation.email)(email);
            var agree = _this.state.agree;
            _this.setState({ emailValid: emailValid });
            if (emailValid) {
                _this.props.setEmail(email);
                _this.props.submitCreateAccount(email, agree);
            }
        }, _this.handleEnterKeyPress = function (event) {
            if (event.key === 'Enter') {
                _this.onSignUp();
            }
            event.stopPropagation();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SignUpEmail, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                bidderExists = _props.bidderExists,
                error = _props.error,
                submitted = _props.submitted;
            var _state = this.state,
                agree = _state.agree,
                email = _state.email,
                emailValid = _state.emailValid;


            var errorMessage = '';
            var errorOnPage = !emailValid || error && !bidderExists;

            var tosLink = (0, _jsx3.default)(_link2.default, {
                to: '/termsandconditions',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'terms_and_conditions'
            }));
            var privacyLink = (0, _jsx3.default)(_link2.default, {
                to: '/privacy',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'privacy_policy'
            }));
            var cookieLink = (0, _jsx3.default)(_link2.default, {
                to: '/cookie-policy',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'cookie_policy'
            }));

            if (!emailValid) {
                errorMessage = (0, _jsx3.default)(_FormattedMessage2.default, {
                    id: 'enter_a_valid_email_address'
                });
            } else if (error && !bidderExists) {
                errorMessage = (0, _jsx3.default)(_FormattedMessage2.default, {
                    id: 'we_experienced_a_server_error'
                }); // we could show the error
            }
            return (0, _jsx3.default)('div', {
                className: _SignUpEmail2.default.body
            }, void 0, (0, _jsx3.default)(_input2.default, {
                autoCapitalize: false,
                autoComplete: false,
                autoCorrect: false,
                autoFocus: true,
                errorMessage: errorMessage,
                id: 'email',
                label: (0, _jsx3.default)(_FormattedMessage2.default, {
                    id: 'email_address'
                }),
                onChange: this.onValueChange,
                onKeyPress: this.handleEnterKeyPress,
                type: 'email',
                valid: !errorOnPage
            }), (0, _jsx3.default)(_Checkbox2.default, {
                className: _SignUpEmail2.default['check-box'],
                checked: agree,
                onChange: this.onAgreeValueChange
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'terms_and_privacy',
                values: { cookieLink: cookieLink, privacyLink: privacyLink, tosLink: tosLink }
            })), (0, _jsx3.default)('div', {
                className: _SignUpEmail2.default.links
            }, void 0, (0, _jsx3.default)(_button2.default, {
                className: _SignUpEmail2.default.submit,
                tertiary: true,
                disabled: submitted || !email || !agree,
                onClick: this.onSignUp
            }, void 0, !submitted ? (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'start_now'
            }) : (0, _jsx3.default)(_throbber2.default, {}))));
        }
    }]);
    return SignUpEmail;
}(_react.Component);

exports.default = SignUpEmail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SignUpModal/SignUpEmail.js
// module id = Dc2Q
// module chunks = 60